import { Controller } from 'stimulus';
import { useDebounce } from 'stimulus-use';

import coopenerEmailRegex from '@/shared/coopener_email_regex.js';

export default class extends Controller {
  static targets = ['email', 'submitButton'];

  static outlets = ['reveal']

  static debounces = [{ name: 'verifyEmail', wait: 350 }];

  connect() {
    useDebounce(this);
  }

  checkForEmail(e) {
    if (this.emailTarget.value.match(coopenerEmailRegex)) {
      this.submitButtonTarget.disabled = true;
      this.verifyEmail(e);
    }
  }

  toggleElements(e) {
    this.revealOutlets.forEach((reveal) => reveal.toggle(e));
  }

  async verifyEmail(e) {
    this.emailTarget.readOnly = true;
    this.toggleElements(e);

    const form = this.element.form || this.element.closest('form');
    form.setAttribute('data-turbo-action', 'replace');
    form.requestSubmit();
  }
}
